<h2 mat-dialog-title>Add Service</h2>
<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content>
    <div *ngIf="errorMessage" class="api-error-banner" style="margin-bottom: 15px;">{{ errorMessage }}</div>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Service Name</mat-label>
      <input matInput type="text" formControlName="serviceName" [matAutocomplete]="serviceAuto" #serviceTrigger="matAutocompleteTrigger" (click)="markServiceInputInteracted()" (keydown)="markServiceInputInteracted()" />
      <app-autocomplete-suffix-actions
        matSuffix
        [showClear]="form.controls.serviceName.value !== ''"
        [panelOpen]="serviceTrigger.panelOpen"
        (clearClicked)="clearSelectedService($event)"
        (toggleClicked)="openOrClosePanel($event, serviceTrigger)">
      </app-autocomplete-suffix-actions>
      <mat-autocomplete #serviceAuto="matAutocomplete" [clearStaleSelectionOnOpen]="form.controls.serviceName.value">
        <mat-option *ngFor="let option of filteredServiceOptions$ | async" [value]="option.ServiceName">
          {{ option.ServiceName }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="form.controls.serviceName.hasError('required')">Required</mat-error>
      <mat-error *ngIf="form.controls.serviceName.hasError('maxlength')">Too long</mat-error>
      <mat-error *ngIf="form.controls.serviceName.hasError('invalidOption')">Select a service from the list</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <textarea matInput 
        [value]="selectedServiceDescription" 
        disabled 
        class="auto-resize-textarea"
        [class.has-value]="selectedServiceDescription"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Start Date</mat-label>
      <input matInput [value]="form.controls.startDate.value | date: 'mediumDate'" disabled />
    </mat-form-field>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid">Submit</button>
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</form>